import { from, Observable, switchMap } from 'rxjs';
import { appConfig } from '../../init/getAppConfig';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getDefaultRequestHeaderParams } from '../../utils/getRequestHeaderParams';
import { getChatApiBaseUrl } from '../../utils/getChatApiBaseUrl';

declare const grecaptcha;

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  constructor(private http: HttpClient) {}

  validateCaptcha(sessionId: string): Observable<any> {
    return from(
      grecaptcha.enterprise.execute(appConfig.recaptchaSiteKey, {
        action: 'escalate',
      })
    ).pipe(
      switchMap((token) =>
        this.http.post(
          getChatApiBaseUrl() + '/ucx-recaptcha/assessment',
          {
            token,
            action: 'escalate',
          },
          {
            headers: {
              ...getDefaultRequestHeaderParams({
                'session-identifier': sessionId,
              }),
            },
            withCredentials: true,
          }
        )
      )
    );
  }
}
